'use strict';

function ForgeError(data, noStack=false) {
    this.message = data.message || "";
    this.type = data.type || "";
    this.uiRefs = data.uiRefs || [];

    this.name = this.constructor.name;
    if (!noStack) {
        this.stack = !!data.stack ? data.stack : (new Error()).stack;
    }
}

ForgeError.prototype.addUIRef = function(uiRef) {
    if(uiRef) {
        this.uiRefs.push(uiRef);
    }
}

ForgeError.prototype = Object.create(Error.prototype);
ForgeError.prototype.constructor = ForgeError;


module.exports = ForgeError;
